import React from 'react';
import '../styles/RentalBanners.scss';

export const RentalBanners = () => (
  <div className="rental-merchant-banners">
    <a href="https://www.homedepot.com/c/Tool_Repair">
      <img
        src="https://assets.homedepot-static.com/online-rental/tool-assets/v4.1.0/img/banner-1.jpg"
        href="https://www.homedepot.com/c/Tool_Repair"
        alt="Repair"
        width="695"
        height="390"
      />
    </a>
    <a href="https://www.homedepot.com/tool-truck-rental/used-tools/">
      <img
        src="https://assets.homedepot-static.com/online-rental/tool-assets/v4.1.0/img/banner-2.jpg"
        href="https://www.homedepot.com/tool-truck-rental/used-tools/"
        alt="Used Tools"
        width="695"
        height="390"
      />
    </a>
  </div>
);